<script setup lang="ts">
import { RouterView } from 'vue-router';

window.addEventListener('beforeprint', () => {
    window.scrollTo(0, 0);
});
</script>

<template>
    <RouterView />
</template>

<style>
</style>
